export default __webpack_public_path__ + "static/media/loading.e1e69349.gif";